/**
 * @generated SignedSource<<8656835c5347d5287f7eee15ee5ad718>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ThemeTabQuery$variables = {
  id: string;
};
export type ThemeTabQuery$data = {
  readonly brand: {
    readonly " $fragmentSpreads": FragmentRefs<"ThemeTab_brand">;
  };
};
export type ThemeTabQuery = {
  response: ThemeTabQuery$data;
  variables: ThemeTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ThemeTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ThemeTab_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThemeTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "collectNameOnRegistration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usePasswordlessLogin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigContentType",
                "kind": "LinkedField",
                "name": "appContent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountDeletionDialogTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountDeletionDialogSubtitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createAccountTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createAccountSubtitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "signInTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "signInSubtitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingRootTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingUpsellTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingUpsellSubtitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notificationsOptInTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notificationsOptInSubtitle",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigBuildThemeType",
                "kind": "LinkedField",
                "name": "buildTheme",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonBorderThickness",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonCartIcon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonCornerRadius",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonTextStyle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "launchScreenOption",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "launchScreenBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "launchScreenLogoUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "launchScreenAssetUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingAssetUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notificationOptInAssetUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logoUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrandAppConfigBuildThemeFontType",
                    "kind": "LinkedField",
                    "name": "fonts",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shouldUseHeaderFontForBody",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iosLiquidGlassEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iosLiquidGlassRequiresNewBuild",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryButtonBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryButtonForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondaryButtonOutline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "badgeBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "badgeForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navigationBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navigationForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryPillBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryPillForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondaryPillOutline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pillContainerBackground",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accent1PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accent2PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accent3PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryPaletteLight",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8debaee66fcc3d191aace4eb6e4a17db",
    "id": null,
    "metadata": {},
    "name": "ThemeTabQuery",
    "operationKind": "query",
    "text": "query ThemeTabQuery(\n  $id: ID!\n) {\n  brand(id: $id) {\n    ...ThemeTab_brand\n    id\n  }\n}\n\nfragment AccountCard_brand on BrandType {\n  appConfig {\n    id\n    collectNameOnRegistration\n    usePasswordlessLogin\n    appContent {\n      id\n      accountDeletionDialogTitle\n      accountDeletionDialogSubtitle\n      createAccountTitle\n      createAccountSubtitle\n      signInTitle\n      signInSubtitle\n    }\n  }\n}\n\nfragment ButtonStyleCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      buttonBorderThickness\n      buttonCartIcon\n      buttonCornerRadius\n      buttonTextStyle\n    }\n  }\n}\n\nfragment ColorsCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n    }\n  }\n}\n\nfragment LaunchScreenCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      launchScreenOption\n      launchScreenBackground\n      launchScreenLogoUrl\n      launchScreenAssetUrl\n    }\n  }\n}\n\nfragment LiquidGlassCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      iosLiquidGlassEnabled\n      iosLiquidGlassRequiresNewBuild\n    }\n  }\n}\n\nfragment LogoCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      logoUrl\n    }\n  }\n}\n\nfragment NotificationsCard_brand on BrandType {\n  appConfig {\n    id\n    appContent {\n      id\n      notificationsOptInTitle\n      notificationsOptInSubtitle\n    }\n    buildTheme {\n      id\n      notificationOptInAssetUrl\n    }\n  }\n}\n\nfragment OnboardingCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      onboardingAssetUrl\n      onboardingBackground\n      onboardingForeground\n    }\n    appContent {\n      id\n      onboardingRootTitle\n      onboardingUpsellTitle\n      onboardingUpsellSubtitle\n    }\n  }\n}\n\nfragment ThemeTab_brand on BrandType {\n  ...AccountCard_brand\n  ...ButtonStyleCard_brand\n  ...ColorsCard_brand\n  ...LaunchScreenCard_brand\n  ...OnboardingCard_brand\n  ...NotificationsCard_brand\n  ...LogoCard_brand\n  ...TypographyCard_brand\n  ...LiquidGlassCard_brand\n  appConfig {\n    id\n    accent1PaletteLight\n    accent2PaletteLight\n    accent3PaletteLight\n    primaryPaletteLight\n    buildTheme {\n      primaryButtonBackground\n      primaryButtonForeground\n      secondaryButtonOutline\n      badgeBackground\n      badgeForeground\n      navigationBackground\n      navigationForeground\n      primaryPillBackground\n      primaryPillForeground\n      secondaryPillOutline\n      pillContainerBackground\n      id\n    }\n  }\n}\n\nfragment TypographyCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      fonts {\n        name\n        type\n        id\n      }\n      shouldUseHeaderFontForBody\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "29f40931ce3282a99215ed919d39d45b";

export default node;
